import { fetchApi } from '@/config/axiosSetting.ts';
import { ReferredFileNumberQueryResponseType } from '@/modules/Dashboard/queries/referredFileNumbers/referredFileNumberQuery.type.ts';

export const referredFileNumberQueryFunction =
  (): Promise<ReferredFileNumberQueryResponseType> =>
    fetchApi({
      url: 'homepage/referred_file_numbers/',
    });
